/* eslint-disable import/default */

import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import Root from './components/Root';
import configureStore, { history } from './store/configureStore';
import initialState from './reducers/initialState';

import '../node_modules/toastr/build/toastr.min.css';
import './styles/eir.css';

require('./favicon.ico'); // Tell webpack to load favicon.ico

const store = configureStore(initialState);

// store.subscribe(() => {
//   console.log(store.getState());
// });

render(

<AppContainer>
<Root store={store} history={history} />
</AppContainer>,
document.getElementById('app')
);

if (module.hot) {
  module.hot.accept('./components/Root', () => {
    const NewRoot = require('./components/Root').default;
    render(
    <AppContainer>
    <NewRoot store={store} history={history} />
    </AppContainer>,
    document.getElementById('app')
  );
  });
}

export default store;

